import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function OurTeam() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>Our Team</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper content-banner-wrapper text-center">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h3>Meet Our Team</h3>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper page-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Vaibhav Senha</h4>
                    <h5>Senior Developers</h5>
                    <p>Vaibhav Senha concentrates on heavy back-end development tasks but is flexible enough to work on front-end development too, if required. An integral member of the Priority Account team, Vaibhav Senha specialises in PHP, MySQL and JavaScript.</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Kuntal Chatterjee</h4>
                    <h5>Senior Developers</h5>
                    <p>Senior programmer and Develops proactive voice. Drives code reviews by using productive questions. Works hard because believes that team is the reflection of its leadership.</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Sarfaraz Sarfaraz</h4>
                    <h5>Senior Developers</h5>
                    <p>Proficient Wordpress, E-commerce, Magento, Shopify, online cart developer. Have tenacity to dig out solution to every related problem</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/female.png" /> </div>
                  <div class="caption">
                    <h4>Gopa Bose </h4>
                    <h5>Senior Developers</h5>
                    <p>specializes in front-end development .NET</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Anupam Roy</h4>
                    <h5>Junior developer</h5>
                    <p>specializes in front-end development PHP</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/female.png" /> </div>
                  <div class="caption">
                    <h4>Tanuja Sen</h4>
                    <h5>Junior developer</h5>
                    <p>specializes in front-end development PHP</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Ankush Mukerjee</h4>
                    <h5>Junior developer</h5>
                    <p>specializes in front-end development .NET</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Santanu Halder</h4>
                    <h5>Junior developer</h5>
                    <p>specializes in front-end development IOS</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 team-grid">
                <div class="team-thumb">
                  <div class="image"> <img class="img-responsive" alt="team-member" src="assets/images/male.png" /> </div>
                  <div class="caption">
                    <h4>Jone Desuza</h4>
                    <h5>Junior developer</h5>
                    <p>Specializes in front-end development PHP</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default OurTeam